import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { LOADING_SPINNER_SERVICE_TOKEN } from '@VineyardLib/services/loading-spinner-wrapper.service';

/**
 * HTTPのinterceptしてLoadingを表示する
 */
export const httpLoadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const loadingSpinnerService = inject(LOADING_SPINNER_SERVICE_TOKEN);
  loadingSpinnerService.showSpinner();
  return next(req).pipe(finalize(() => loadingSpinnerService.hideSpinner()));
};
